import {getParameterByName} from "./queryParamsHelper";
import {PARAMETERS} from "config/parameters";

const MODE_QUERY = 'env-mode';

const MODES = {
    STAGING: 'staging',
    DEV: 'dev',
};

export class StagingProvider {
    constructor() {
        this.mode = getParameterByName(MODE_QUERY);
    }

    get isMocked() {
        return Boolean(this.mode);
    }

    get isStaging() {
        return this.mode === MODES.STAGING;
    }

    get isDev() {
        return this.mode === MODES.DEV;
    }

    classifyApi() {
        switch (true) {
        case this.isStaging:
            return PARAMETERS.API_RELEASE;
        case this.isDev:
            return PARAMETERS.API_DEV;
        default:
            return false;
        }
    }
}